import React from 'react';
import '../styles/Form.css';

const FormSuccess = () => {
  return (
    <div className='form-content-right-success'>
      <h1 className="form-success"><i className="fas fa-paper-plane"></i> Mensaje enviado con éxito</h1>
    </div>
  );
};

export default FormSuccess;
